<template>
  <dashboard-panel
    title="File & Tag"
    icon="fa-tag"
    :tabs="tabs"
    :active-tab="search_params.mine_only == 1 ? 'you' : 'all'"
    :count="count"
    add-label="upload documents"
    :add-permissions="['can_upload']"
    :add-to="{ name: 'upload', params: { vault_id: $route.params.vault_id } }"
    :loading="fetching"
    :empty="!get_result.total"
    empty-text="No documents found"
    :pager="get_result"
    @tab="selectTab"
    @page="goToPage"
  >
    <dashboard-list-item
      v-for="file in files_for_tagging"
      :key="file.id"
      :author="getUser(file.user_id)"
      :date="file.created_at"
      :title="file.filename"
      :body="getFileSize(file)"
      @click="goTo(file.vault_id, file.id)"
    ></dashboard-list-item>
  </dashboard-panel>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import DashboardPanel from "./DashboardPanel.vue";
import DashboardListItem from "./DashboardListItem.vue";

export default {
  components: {
    DashboardPanel,
    DashboardListItem,
  },

  props: ["all-users", "vault"],

  data() {
    return {
      files_for_tagging: {},
      get_result: {},

      fetching: false,
      fetch_cancel: null,
      count: 0,

      search_params: {
        mine_only: 1,
        current_page: 1,
        items_per_page: 5,
      },

      tabs: [
        { key: "you", label: "You" },
        { key: "all", label: "All" },
      ],
    };
  },

  mounted() {
    this.getFilesForTagging();

    this.$ebus.$on("refresh-file-and-tag-panel", () => {
      this.getFilesForTagging();
    });
  },

  methods: {
    selectTab(key) {
      this.search_params.mine_only = key == "you" ? 1 : 0;
      this.search_params.current_page = 1;
      this.getFilesForTagging();
    },

    goToPage(page) {
      this.search_params.current_page = page;
      this.getFilesForTagging();
    },

    getFilesForTagging: _.debounce(function () {
      if (this.fetch_cancel) {
        this.fetch_cancel.cancel();
      }

      let cancel_token = axios.CancelToken;
      this.fetch_cancel = cancel_token.source();

      this.fetching = true;

      axios
        .get(
          `/api/vaults/${this.$route.params.vault_id}/files/for-tagging`,
          {
            params: {
              mine_only: this.search_params.mine_only,
              page: this.search_params.current_page,
              items_per_page: this.search_params.items_per_page,
            },
          },
          { cancelToken: this.fetch_cancel.token }
        )
        .then(({ data }) => {
          this.count = data.total;
          this.files_for_tagging = data.data;
          this.get_result = data;
          this.fetching = false;
          this.fetch_cancel = null;
        })
        .catch((error) => {
          this.fetch_cancel = null;
        });
    }, 200),

    getUser(id) {
      let user = _.filter(this.allUsers, { id: id });

      if (!_.isEmpty(user)) {
        return user[0].first_name + " " + user[0].last_name;
      }

      return "-";
    },

    getFileSize(file) {
      if (file.size == 0) return "0 Bytes";
      var k = 1000,
        dm = 2 || 2,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(file.size) / Math.log(k));
      return parseFloat((file.size / Math.pow(k, i)).toFixed(dm)) + sizes[i];
    },

    goTo(vault_id, file_id) {
      if (this.search_params.mine_only == 0) {
        this.$authorize
          .isAuthorized([this.role], ["can_access_all_files"])
          .then(() => {
            this.$router
              .push({
                name: "tagging",
                params: {
                  vault_id: vault_id,
                  open_file: true,
                  file_id: file_id,
                  mine_only: this.search_params.mine_only,
                },
              })
              .catch((err) => {
                if (err.name != "NavigationDuplicated") {
                  throw err;
                }
              });
          })
          .catch(() => {
            this.$noty.warning("You are unauthorized to view this file!", {
              killer: true,
              timeout: 2000,
            });
          });
      } else {
        this.$router
          .push({
            name: "tagging",
            params: {
              vault_id: vault_id,
              open_file: true,
              file_id: file_id,
            },
          })
          .catch((err) => {
            if (err.name != "NavigationDuplicated") {
              throw err;
            }
          });
      }
    },
  },

  computed: {
    ...mapGetters({
      role: "getUserRole",
    }),
  },

  watch: {
    "$route.params.vault_id"() {
      _.delay(() => {
        this.getFilesForTagging();
      }, 1000);
    },
  },
};
</script>
